// src/components/ModeloSpecs.js
import React from 'react';
import './ModeloSpecs.css'; // Importamos los estilos

const ModeloSpecs = ({ specs }) => {
  // Obtenemos las primeras tres especificaciones
  const firstThreeSpecs = specs.slice(0, 3);

  return (
    <div className="modelo-specs">
      {firstThreeSpecs.map((spec, index) => (
        <div key={index} className="modelo-spec">
          <div className="modelo-spec-value">{spec.value}</div>
          <div className="modelo-spec-name">{spec.name}</div>

        </div>
      ))}
    </div>
  );
};

export default ModeloSpecs;
